import { extractSize, extractSizeWidthHeight } from "./extractSize";

export const getTableName = (loadData) => {
    const { pageName, objectWidth, glbName, folderName, tempName, defaultDepth, name, objectName, wardrobeType } =
        loadData;

    const isVerstak = pageName === "verstak";
    const isStoyka = folderName === "stoyki_podkatnie";
    const isStolPodkatnoi = folderName === "stoli_podkatnie";
    const isTelezhka = folderName === "telezhki";
    const isTumba = folderName === "tumbi";
    const isStellazh = folderName === "stellazhi";
    const isStul = folderName === "stulya";
    const isVerstakCategory = folderName === "verstaki";
    const isWardrobe = folderName === "wardrobes";

    const withHeight = isStellazh || isWardrobe;

    const objectSize = withHeight ? extractSizeWidthHeight(name ?? objectName) : extractSize(name ?? objectName);

    if (isVerstak) {
        return `${pageName}_${objectWidth}_t1`;
    }
    if (isVerstakCategory) {
        return `verstak__${tempName}__${objectSize}_t1`;
    }
    if (isStoyka) {
        const withoutExt = glbName.replace(/\.glb$/i, "");
        return `${withoutExt}__${objectSize}`;
    }
    if (isStolPodkatnoi) {
        return `stol__${pageName}__${objectSize}`;
    }
    if (isTelezhka && tempName === "tm") {
        return `telezhka__${tempName}__${defaultDepth}`;
    }
    if (isTelezhka) {
        return `telezhka__${pageName}`;
    }
    if (isTumba) {
        return `tumba__${pageName}`;
    }
    if (isStellazh) {
        return `stellazh__${pageName}__${objectSize.height}x${objectSize.width}x${objectSize.depth}`;
    }
    if (isStul) {
        return `stul__${pageName}`;
    }
    if (isWardrobe) {
        const isInstrumentalniy = pageName === "instrumentalniy";

        return isInstrumentalniy
            ? `shkaf__${wardrobeType}__${objectSize.height}`
            : `shkaf__${pageName}__${objectSize.height}`;
    }
    return `${pageName}__${objectSize}`;
};
